import React from 'react'
import QuestionText from '../QuestionText'

export const TextAnswerSummary = ({ params: { id, heading }, answers }) => {
  const text = answers[id]

  return text ? <QuestionText params={{ heading, text }} /> : null
}
